import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, PopoverController} from 'ionic-angular';
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";
import * as moment from "moment";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";

/**
 * Generated class for the AppPausePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-pause',
  templateUrl: 'app-pause.html',
})
export class AppPausePage {

  selectedStartDate: any;
  selectedEndDate: any;
  selectedStartDateFormatted: any;
  selectedEndDateFormatted: any;
  openedPopover: any;

  removalMode: boolean;
  errorVisible: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public contentTranslation: ContentTranslationProvider,
    private loadingCtrl: LoadingController,
    private api: ApiProvider,
    private userState: UserStateProvider
  ) {
    moment.updateLocale('de', function () {
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppPausePage');

    let todayDate = new Date().toISOString().substr(0, 10);
    if(this.userState.user.pauseEndDate && this.userState.user.pauseEndDate >= todayDate) {
      this.selectedEndDate = new Date(this.userState.user.pauseEndDate);
      this.formatSelectedDate('selectedEndDate');
      this.selectedStartDate = new Date(this.userState.user.pauseStartDate);
      this.formatSelectedDate('selectedStartDate');

      this.removalMode = true;
    }
  }

  openDatePickerPopover(event, field) {
    console.log('open date picker popover', event);
    if(this.openedPopover) {
      return ;
    }
    this.openedPopover = this.popoverCtrl.create(
      DatePickerPopoverPage,
      {
        currentSelection: this[field]?this[field].toISOString().substr(0, 10):null,

        valueUpdated: (selectedDate) => {
          this[field] = new Date(selectedDate);
          this.formatSelectedDate(field);

          if(field == 'selectedStartDate' && this.selectedEndDate && this.selectedStartDate > this.selectedEndDate) {
            this.selectedEndDate = this.selectedStartDate;
            this.formatSelectedDate('selectedEndDate');
          }
          if(field == 'selectedEndDate' && this.selectedEndDate && this.selectedStartDate > this.selectedEndDate) {
            this.selectedStartDate = this.selectedEndDate;
            this.formatSelectedDate('selectedStartDate');
          }

        }
      },
      {cssClass: 'date-picker-popover-container'}
    );
    this.openedPopover.present({
      ev: event,
    });
    this.openedPopover.onDidDismiss(() => {
      this.openedPopover = null;
    })
  }

  cancelInputClick(ev, field) {
    console.log(ev);

    this.openDatePickerPopover(ev, field);
    ev.stopPropagation();
  }

  formatSelectedDate(field) {
    this.errorVisible = false;
    this.removalMode = false;
    let formattedField = field+'Formatted';
    this[formattedField] = moment(this[field]).format('dd, ll');
  }

  savePause() {
    if(this.selectedStartDate && this.selectedEndDate && this.selectedStartDate <= this.selectedEndDate) {
      var loading = this.loadingCtrl.create({})
      loading.present();

      this.api.callPut('/users/'+this.userState.user.id, {pauseStartDate: this.selectedStartDate.toISOString(), pauseEndDate: this.selectedEndDate.toISOString()}).subscribe((res:any) => {
        this.userState.user.pauseStartDate = this.selectedStartDate.toISOString().substr(0, 10);
        this.userState.user.pauseEndDate = this.selectedEndDate.toISOString().substr(0, 10);
        this.navCtrl.pop();
        loading.dismissAll()
      }, () => {
        loading.dismissAll();
        this.errorVisible = true;
      })


    } else {
      this.errorVisible = true;
    }
  }

  removePause() {
    var loading = this.loadingCtrl.create({})
    loading.present();

    this.api.callPut('/users/'+this.userState.user.id, {pauseStartDate: null, pauseEndDate: null}).subscribe((res:any) => {
      this.userState.user.pauseStartDate = null;
      this.userState.user.pauseEndDate = null;
      this.navCtrl.pop();
      loading.dismissAll()
    }, () => {
      loading.dismissAll();
      this.errorVisible = true;
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/app-pause/app-pause.ts